<template>
  <div class="grid-wrapper">
    <div class="dynamic-grid mt-4">
      <!-- Header row -->
      <div class="row header">
        <div class="cell row-index">#</div>
        <div
          v-for="letter in columnLetters"
          :key="letter"
          class="cell header-cell"
        >
          <strong>{{ letter }}</strong>
        </div>
      </div>

      <!-- Data rows -->
      <div v-for="(line, rowIndex) in items" :key="rowIndex" class="row">
        <div class="cell row-index">{{ rowIndex + 1 }}</div>
        <div
          v-for="(value, colIndex) in line"
          :key="colIndex"
          class="cell"
        >
          {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array, // Array of arrays
      required: true
    }
  },
  computed: {
    columnLetters() {
      const maxCols = Math.max(...this.items.map(row => row.length));
      return Array.from({ length: maxCols }, (_, i) => this.toExcelColumn(i + 1));
    }
  },
  methods: {
    // Convert number -> Excel column letters (1=A, 2=B, ... 27=AA, 28=AB)
    toExcelColumn(num) {
      let column = "";
      while (num > 0) {
        const remainder = (num - 1) % 26;
        column = String.fromCharCode(65 + remainder) + column;
        num = Math.floor((num - 1) / 26);
      }
      return column;
    }
  }
};
</script>

<style scoped>
.grid-wrapper {
  max-width: 100%;
  max-height: 80vh;
  overflow: auto;
  padding-bottom: 8px;
  margin: 0 auto;
}

.dynamic-grid {
  display: flex;
  flex-direction: column;
  border: 1px solid #000;
  background-color: #fff;
  min-width: max-content;
}

.row {
  display: flex;
  border-top: 1px solid #000;
}

.header {
  background-color: var(--v-primaryLighter-base);
  border-bottom: 2px solid #000;
  font-weight: bold;
}
.cell {
  padding: 8px;
  border-right: 1px solid #000;
  min-width: 120px;   /* give a consistent width */
  max-width: 120px;   /* enforce fixed width */
  text-align: center;
  background-color: #fff;

  /* Handle long text */
  white-space: normal;   /* allow wrapping */
  word-break: break-word; /* break long words */
}

.header-cell {
  background-color: var(--v-primaryLighter-base);
  font-weight: bold;
}

.row-index {
  font-weight: bold;
  background-color: #F4F4F4;
  min-width: 40px; 
  max-width: 40px; 
}
</style>
